import { FC, PropsWithChildren } from "react";
import { FeatureContext } from "./Feature.context";
import { FeatureProps } from "./Feature.types";

const FeatureProvider: FC<PropsWithChildren & FeatureProps> = ({ children, ...props }) => {
    return <FeatureContext.Provider value={{ featureKey: props.featureKey }}>{children}</FeatureContext.Provider>;
};

export default FeatureProvider;
